export const GET_CHATS_PENDING = 'CHAT/GET_CHATS_PENDING';
export const GET_CHATS_SUCCESS = 'CHAT/GET_CHATS_SUCCESS';
export const GET_CHATS_FAILURE = 'CHAT/GET_CHATS_FAILURE';
export const RESET_CHATS = 'CHAT/RESET_CHATS';
export const SAVE_CHATS_PENDING = 'CHAT/SAVE_CHATS_PENDING';
export const SAVE_CHATS_SUCCESS = 'CHAT/SAVE_CHATS_SUCCESS';
export const SAVE_CHATS_FAILURE = 'CHAT/SAVE_CHATS_FAILURE';
export const MARK_READ_CHATS_PENDING = 'CHAT/MARK_READE_CHATS_PENDING';
export const MARK_READ_CHATS_SUCCESS = 'CHAT/MARK_READE_CHATS_SUCCESS';
export const MARK_READ_CHATS_FAILURE = 'CHAT/MARK_READ_CHATS_FAILURE';
export const SEND_TECH_CHATS_PENDING = 'CHAT/SEND_TECH_CHATS_PENDING';
export const SEND_TECH_CHATS_SUCCESS = 'CHAT/SEND_TECH_CHATS_SUCCESS';
export const SEND_TECH_CHATS_FAILURE = 'CHAT SEND_TECH_CHATS_FAILURE';
export const SIGNER_ACTION_REQUIRED_PENDING = 'CHAT/SIGNER_ACTION_REQUIRED_PENDING';
export const SIGNER_ACTION_REQUIRED_SUCCESS = 'CHAT/SIGNER_ACTION_REQUIRED_SUCCESS';
export const SIGNER_ACTION_REQUIRED_FAILURE = 'CHAT/SIGNER_ACTION_REQUIRED_FAILURE';
export const MISSING_ITEM_REQUESTED_PENDING = 'CHAT/MISSING_ITEM_REQUESTED_PENDING';
export const MISSING_ITEM_REQUESTED_SUCCESS = 'CHAT/MISSING_ITEM_REQUESTED_SUCCESS';
export const MISSING_ITEM_REQUESTED_FAILURE = 'CHAT/MISSING_ITEM_REQUESTED_FAILURE';
export const INCORPORATE_INTO_RETURN_PENDING = 'CHAT/INCORPORATE_INTO_RETURN_PENDING';
export const INCORPORATE_INTO_RETURN_SUCCESS = 'CHAT/INCORPORATE_INTO_RETURN_SUCCESS';
export const INCORPORATE_INTO_RETURN_FAILURE = 'CHAT/INCORPORATE_INTO_RETURN_FAILURE';
export const GET_CHATS_COUNTS_PENDING = 'CHAT/GET_CHATS_COUNTS_PENDING';
export const GET_CHATS_COUNTS_SUCCESS = 'CHAT/GET_CHATS_COUNTS_SUCCESS';
export const GET_CHATS_COUNTS_FAILURE = 'CHAT/GET_CHATS_COUNTS_FAILURE';



// WEBPACK FOOTER //
// ./src/ui/features/Chat/state/chatTypes.js